// componente per la visualizzazione e gestione della tabella contenente tutti i pannelli (componente destra)
// nella pagina "Pannelli"

import { Component, ViewChild, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { BodyService } from '../body.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';;
import { Body } from '../body.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '../../../../service/authentication.service';
import { UtilsService } from '../../../../service/helper/utils.service';

@Component({
  selector: 'app-body-list',
  templateUrl: './body-list.component.html',
  styleUrls: ['style.scss']
})
export class BodyListComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;

  // inizializzazione array con tutti i pannelli da mostrare nella tabella
  dataSource: MatTableDataSource<Body>;

  // inizializzazione id, profilo e array con tutti gli indici dei messaggi nella tabella
  public id: number
  profile: string
  index = []
  filterValues = {};
  filterSelectObj = [];
  // colonne da mostrare nella tabella (ciascuna etichetta è definita nella pagina html)
  displayedColumns: string[] = ['id', 'name', 'tag', 'actions', 'reset'];

  constructor(private authenticationService: AuthenticationService, private bodyService: BodyService,
    private changeDetectorRefs: ChangeDetectorRef, private utilsService: UtilsService) {
      this.filterSelectObj = [
        {
          name: 'ID',
          columnProp: 'id',
          options: []
        }, {
          name: 'Nome',
          columnProp: 'name',
          options: []
        }, {
          name: 'Tag',
          columnProp: 'tag',
          options: []
        }
      ]
  }

  // metodi necessari per aggiornare la tabella in seguito ad interazioni (modifiche, aggiunte, cancellazioni)
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();

  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = this.createFilter();
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  filterChange(filter, event) {
    //let filterValues = {}
    filter.columnProp == "id" ? this.filterValues[filter.columnProp] = parseInt(event.target.value) : this.filterValues[filter.columnProp] = event.target.value
    this.dataSource.filter = JSON.stringify(this.filterValues)
  }
  // Reset table filters
  resetFilters() {
    this.filterValues = {}
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
    })
    this.dataSource.filter = "";
  }
  getFilterObject(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    var ret = uniqChk.sort()
    return ret;
  }
  // Custom filter method fot Angular Material Datatable
  createFilter() {
    let filterFunction = function (data: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);

      var found = 0
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '') {
          if (data[col] === searchTerms[col]) {
            found++
          }

        } else {
          delete searchTerms[col];
        }
      }
      return found == Object.keys(searchTerms).length
    }
    return filterFunction
  }

  // la prima cosa da fare entrando nella pagina è richiamare il metodo di popolamento tabella
  ngOnInit() {
    this.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // si imposta il profilo corrente
    this.profile = this.authenticationService.currentUserValue.profile

    // si richiede all'apposito servizio la lista di pannelli e si popola la tabella, applicandone le opportune opzioni
    // (dal paginator, al sort)
    this.dataSource = new MatTableDataSource(this.bodyService.getBody());
    this.subscription = this.bodyService.bodyChanged.subscribe(
      (bodys: Body[]) => {
        this.dataSource = new MatTableDataSource(bodys);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento

        this.dataSource.filterPredicate = this.createFilter();
        this.filterSelectObj.filter((o) => {
          o.options = this.getFilterObject(this.bodyService.getBody(), o.columnProp);
        });
        this.changeDetectorRefs.detectChanges();
        this.resetFilters()
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento

      }
    );
  }

  // metodo richiamato al click del pulsante "modifica" in una riga della tabella
  onEdit(val) {
    var id = val.id
    this.bodyService.editBody(id);
  }

  // metodo richiamato alla chiusura della pagina "Pannelli"
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // metodo richiamato dalla componente "PanelEdit": permette di riempire la form di modifica messaggio con tutti i dati
  // relativi al messaggio il cui ID viene indicato in ingresso
  getIndex(ids) {
    this.dataSource = new MatTableDataSource(this.bodyService.getBody());
    this.index = []
    for (var i = 0; i < this.dataSource.filteredData.length; i++) {
      this.index.push({
        "id": this.dataSource.filteredData[i].id,
        "edit": i
      })
    }
    var result = this.index.find(obj => {
      return obj.id == ids
    })
    return result.edit
  }
  downloadFile(data, filename = 'data') {
    let csvData = this.ConvertToCSV(data, ['id', 'name', 'tag']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray, headerList) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    array.forEach(function (v) {
      delete v.timestamp
    });
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}` + '\r\n';
    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}` + '\r\n';
      return str.replace(/['"]+/g, '');
    }, str.replace(/['"]+/g, ''))
  }
  download() {
    this.downloadFile(this.bodyService.getBody(), 'enti');
  }
}
